module.exports = __webpack_public_path__ + "img/id-icon.28f0de80.svg";